import { useEffect } from 'react';
const PIXEL_ID = '28337288762539657';
declare global {
  interface Window {
    fbq?: ((...args: unknown[]) => void) & {
      callMethod?: (...args: unknown[]) => void;
      queue?: unknown[];
      push?: unknown;
      loaded?: boolean;
      version?: string;
    };
    _fbq?: unknown;
  }
}

/**
 * Meta Pixel. Loaded after first paint and with an async script so it never
 * blocks rendering of the offer page.
 */
export function MetaPixel() {
  useEffect(() => {
    if (document.getElementById('meta-pixel')) return;
    const fbq: Window['fbq'] = window.fbq || function (...args: unknown[]) {
      const instance = window.fbq!;
      if (instance.callMethod) instance.callMethod(...args);else instance.queue!.push(args);
    };
    if (!window._fbq) window._fbq = fbq;
    window.fbq = fbq;
    fbq.push = fbq;
    fbq.loaded = true;
    fbq.version = '2.0';
    fbq.queue = fbq.queue || [];
    const script = document.createElement('script');
    script.id = 'meta-pixel';
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    fbq('init', PIXEL_ID);
    fbq('track', 'PageView');
  }, []);
  return <noscript data-id="element-84" data-mp="1ido79rook81z">
      <img height="1" width="1" style={{
      display: 'none'
    }} src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-85" data-mp="1ie7nn3yomodw" />
    </noscript>;
}